/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './select-venue.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/forms';
import * as i3 from '@ngx-translate/core/src/translate.pipe';
import * as i4 from '@ngx-translate/core/src/translate.service';
import * as i5 from '../../../../../../../app/modules/employee/pages/venues/select-venue/select-venue.component';
import * as i6 from '@angular/common';
import * as i7 from '../../../../../../../app/modules/employee/service/venue/venue.service';
const styles_SelectVenueComponent:any[] = [i0.styles];
export const RenderType_SelectVenueComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_SelectVenueComponent,data:{}});
function View_SelectVenueComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'option',([] as any[]),
      [[8,'selected',0]],(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(1,147456,(null as any),0,i2.NgSelectOption,[i1.ElementRef,i1.Renderer2,
          [8,(null as any)]],{value:[0,'value']},(null as any)),i1.ɵdid(2,147456,(null as any),
          0,i2.ɵq,[i1.ElementRef,i1.Renderer2,[8,(null as any)]],{value:[0,'value']},
          (null as any)),(_l()(),i1.ɵted(3,(null as any),['',' - ',''])),i1.ɵpid(131072,
          i3.TranslatePipe,[i4.TranslateService,i1.ChangeDetectorRef])],(_ck,_v) => {
    const currVal_1:any = i1.ɵinlineInterpolate(1,'',_v.context.$implicit.id,'');
    _ck(_v,1,0,currVal_1);
    const currVal_2:any = i1.ɵinlineInterpolate(1,'',_v.context.$implicit.id,'');
    _ck(_v,2,0,currVal_2);
  },(_ck,_v) => {
    const currVal_0:any = _v.context.$implicit.selected;
    _ck(_v,0,0,currVal_0);
    const currVal_3:any = ((_v.context.$implicit.company == null)? (null as any): _v.context.$implicit.company.name);
    const currVal_4:any = i1.ɵunv(_v,3,1,i1.ɵnov(_v,4).transform(_v.context.$implicit.name));
    _ck(_v,3,0,currVal_3,currVal_4);
  });
}
export function View_SelectVenueComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{textarea:0}),(_l()(),i1.ɵeld(1,0,[[1,0],['input',
      1]],(null as any),4,'select',[['class','form-control']],[[8,'disabled',0]],[[(null as any),
      'change']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i5.SelectVenueComponent = _v.component;
    if (('change' === en)) {
      const pd_0:any = ((<any>_co.change($event)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),
      i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_SelectVenueComponent_1)),
      i1.ɵdid(4,802816,(null as any),0,i6.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(-1,
          (null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i5.SelectVenueComponent = _v.component;
    const currVal_1:any = _co.venuesOptions;
    _ck(_v,4,0,currVal_1);
  },(_ck,_v) => {
    var _co:i5.SelectVenueComponent = _v.component;
    const currVal_0:any = _co.disabled;
    _ck(_v,1,0,currVal_0);
  });
}
export function View_SelectVenueComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),2,'app-select-venue',
      ([] as any[]),(null as any),(null as any),(null as any),View_SelectVenueComponent_0,
      RenderType_SelectVenueComponent)),i1.ɵprd(5120,(null as any),i2.NG_VALUE_ACCESSOR,
      (p0_0:any) => {
        return [p0_0];
      },[i5.SelectVenueComponent]),i1.ɵdid(2,638976,(null as any),0,i5.SelectVenueComponent,
      [i1.Renderer2,i7.VenueService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,2,0);
  },(null as any));
}
export const SelectVenueComponentNgFactory:i1.ComponentFactory<i5.SelectVenueComponent> = i1.ɵccf('app-select-venue',
    i5.SelectVenueComponent,View_SelectVenueComponent_Host_0,{venueId:'venueId',disabled:'disabled'},
    {onMyChange:'onMyChange'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvdmVudWVzL3NlbGVjdC12ZW51ZS9zZWxlY3QtdmVudWUuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0Q6L2luZXRwdWIvd3d3cm9vdC9rYWl6ZW4tbmcvc3JjL2FwcC9tb2R1bGVzL2VtcGxveWVlL3BhZ2VzL3ZlbnVlcy9zZWxlY3QtdmVudWUvc2VsZWN0LXZlbnVlLmNvbXBvbmVudC50cyIsIm5nOi8vL0Q6L2luZXRwdWIvd3d3cm9vdC9rYWl6ZW4tbmcvc3JjL2FwcC9tb2R1bGVzL2VtcGxveWVlL3BhZ2VzL3ZlbnVlcy9zZWxlY3QtdmVudWUvc2VsZWN0LXZlbnVlLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvdmVudWVzL3NlbGVjdC12ZW51ZS9zZWxlY3QtdmVudWUuY29tcG9uZW50LnRzLlNlbGVjdFZlbnVlQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHNlbGVjdCAjaW5wdXQgKGNoYW5nZSk9XCJjaGFuZ2UoJGV2ZW50KVwiIGNsYXNzPVwiZm9ybS1jb250cm9sXCIgW2Rpc2FibGVkXT1cImRpc2FibGVkXCI+XHJcbiAgICA8b3B0aW9uIHZhbHVlPVwie3t2ZW51ZS5pZH19XCIgKm5nRm9yPVwibGV0IHZlbnVlIG9mIHZlbnVlc09wdGlvbnNcIiBbc2VsZWN0ZWRdPVwidmVudWUuc2VsZWN0ZWRcIj57e3ZlbnVlLmNvbXBhbnk/Lm5hbWV9fSAtIHt7dmVudWUubmFtZSB8IHRyYW5zbGF0ZX19PC9vcHRpb24+XHJcbjwvc2VsZWN0PlxyXG4iLCI8YXBwLXNlbGVjdC12ZW51ZT48L2FwcC1zZWxlY3QtdmVudWU+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQ0k7TUFBQTthQUFBO1VBQUEsNkRBQUE7VUFBQTtVQUFBLGVBQTZGOzJCQUFBO0lBQXJGO0lBQVIsV0FBUSxTQUFSO0lBQVE7SUFBUixXQUFRLFNBQVI7O0lBQWlFO0lBQWpFLFdBQWlFLFNBQWpFO0lBQTZGO0lBQUE7SUFBQTs7OztzREFEakc7TUFBQTtNQUFBO0lBQUE7SUFBQTtJQUFlO01BQUE7TUFBQTtJQUFBO0lBQWY7RUFBQSxnQ0FBb0YsOENBQ2hGO2FBQUE7YUFBQTs0QkFBQSx5Q0FBMEo7VUFBQSx1QkFDcko7O0lBRHdCO0lBQTdCLFdBQTZCLFNBQTdCOzs7SUFEMEQ7SUFBOUQsV0FBOEQsU0FBOUQ7Ozs7b0JDQUE7TUFBQTtxQ0FBQTtNQUFBO1FBQUE7TUFBQSxvQ0FBQTtNQUFBO0lBQUE7Ozs7OyJ9



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/modules/employee/pages/venues/select-venue/select-venue.component.ngfactory.ts